/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import ProductItem from '../ProductItem';

const OtherSimilarProducts = ({ products }) => (
    <div className="other-similar-products">
        <div className="title is-size-3-touch is-size-2-desktop has-text-centered is-spaced">
            Other Choices
        </div>
        <div className="subtitle is-size-5-touch is-size-4-desktop has-text-centered">
            {`Choose from a variety of  DR WATSON ${products.length > 0 ? products[0].productgroup.name.toLowerCase() : ''} products`}
        </div>
        <div className="columns is-multiline is-centered container is-mobile">
            {
                products
                    .map(
                        product => product.variants.map(
                            variant => (
                                <ProductItem
                                    product={{
                                        ...product,
                                        variant,
                                    }}
                                />
                            ),
                        ),
                    )
            }
        </div>
    </div>
);

OtherSimilarProducts.defaultProps = {
    products: [],
};

OtherSimilarProducts.propTypes = {
    products: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            description: PropTypes.string,
            slug: PropTypes.string.isRequired,
            variant: PropTypes.shape({
                name: PropTypes.string,
                description: PropTypes.string,
                price: PropTypes.number,
                images: PropTypes.arrayOf(
                    PropTypes.shape({
                        createdAt: PropTypes.string,
                        url: PropTypes.string,
                    }),
                ),
            }).isRequired,
        }).isRequired,
    ),
};

export default OtherSimilarProducts;
